import React from 'react'
import {Link} from 'react-router-dom'


export default class extends React.Component {

  render() {
    return (
      <div>

        <div className="full greyish pure-g">
        <div style={{position:"absolute", top:"-25px", right:"12px"}}>
          <div>
            <Link to="/start" style={{marginRight:"14px"}}>Home</Link>
            {!this.props.session_token && <Link to="/" onClick={(e) => this.props.openModal(e)} className="cta">Login</Link>}
            {this.props.session_token && <Link to="/" className="cta">Dashboard</Link>}
          </div>
        </div>
          <div className="wrap wrap-thin pure-u-1">
            <small style={{opacity:".5", display:"block", marginTop:"3em", fontSize:"75%", textAlign:"justify"}}>These are some random milestones, to keep you updated on the progress of the platform. The intent is to be open and honest about the growth of BountyHub.NET.</small>
            <div className="pure-u-1 timeline">

              <div className="pure-u-1 tl-item">
                <div className="pure-u-1 pure-u-md-1-3 tl-stamp">
                  <p>Coming soon</p>
                </div>
                <div className="pure-u-1 pure-u-md-2-3 tl-content">
                  <h1>Twenty-fifth registration!</h1>
                  <p>The next milestone would be the first 25 registrations.</p>
                </div>
              </div>

              <div className="pure-u-1 tl-item">
                <div className="pure-u-1 pure-u-md-1-3 tl-stamp">
                  <p>03-04-2024</p>
                </div>
                <div className="pure-u-1 pure-u-md-2-3 tl-content">
                  <h1>Tenth registration!</h1>
                  <p>After reaching out to a lot of streamers on Twitter, a fairly high percentage decided to sign up and check out BountyHub.</p>
                </div>
              </div>

              <div className="pure-u-1 tl-item">
                <div className="pure-u-1 pure-u-md-1-3 tl-stamp">
                  <p>26-03-2024</p>
                </div>
                <div className="pure-u-1 pure-u-md-2-3 tl-content">
                  <h1>First registration!</h1>
                  <p>Without reaching out, this user found BountyHub.NET through social media and decided to sign up.</p>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Milestones.js